import axios from 'axios'

const accessToken = localStorage.getItem('accessToken');
const base = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: 'Bearer ' + accessToken
  }
});

const Api = {
  getAppointment(agendaId, id) {
    return base.get(agendaId + '/' + id);
  },
  cancelAppointment(agendaId, id) {
    return base.put(agendaId + '/' + id + '/cancel');
  },
  makePayment(agendaId, id, paymentData) {
    return base.post(agendaId + '/' + id + '/payment', paymentData);
  },
  generatePix(agendaId, id, paymentData) {
    return base.post(agendaId + '/' + id + '/generate-pix', paymentData);
  },
  checkPix(agendaId, id) {
    return base.get(agendaId + '/' + id + '/check-pix-payment');
  },
  cancelPix(agendaId, id) {
    return base.put(agendaId + '/' + id + '/delete-pix-payment');
  },




  getAgenda(agendaId, agendaData = {}) {
    return base.get(agendaId, { params: agendaData});
  },
  makeAppointment(agendaId, appointmentData) {
    return base.post(agendaId, appointmentData);
  },
};

export default Api
